import React, {useContext} from 'react';
import Context from '../OriginStoryProvider';
import DeepDiveParagraph from '../Shared/DeepDiveParagraph';

const DeepDive4 = () => {
	const { data: {content} } = useContext(Context);

	const deepDiveImages = {
		'deep_dive_4_1': {
			images: [
				{
					'img_src': `${mainScript.assetPath}images/png/chapter-3/1927-scripps-rolls-royce-limo-yosemite.png`,
					'img_alt': ''
				},	
			]
		}
	}

	return (
		<div className='chapter-3__large-quote-and-media-text-3__media-text__deep-dive'>
			<p className='chapter-3__large-quote-and-media-text-3__media-text__deep-dive__title'>{content.chapters.third.deep_dive_section_4.title}</p>
			<div className='chapter-3__large-quote-and-media-text-3__media-text__deep-dive__text-container'>
				<p>{content.chapters.third.deep_dive_section_4.paragraph_1}</p>
				<DeepDiveParagraph 
					paragraph={content.chapters.third.deep_dive_section_4.paragraph_2}
					elClass='chapter-3__large-quote-and-media-text-3__media-text__deep-dive'
					chapterNum='third'
					section='deep_dive_section_4'
					deepDiveImages={deepDiveImages}
				/>
			</div>
		</div>
	)
}

export default DeepDive4;